import { ASSETS } from '../../../../constants/redLightGreenLightConfig';
import { GameStartScreen } from '../common/GameStartScreen';

interface RedLightGameStartScreenProps {
  onGameStart: () => void;
}

export const RedLightGameStartScreen = ({ onGameStart }: RedLightGameStartScreenProps) => {
  return (
    <GameStartScreen onGameStart={onGameStart}>
      <img src={ASSETS.guide.background} alt="red-light-green-light-guide" />
    </GameStartScreen>
  );
};
